import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { reportBannerMode } from '../report-schedule.helpers';
import { ReportScheduleDto } from '../report-schedule.types';

@Component({
  selector: 'mbtr-report-schedule-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './report-schedule-banner.html',
})
export class ReportScheduleBanner {
  readonly schedule = input<ReportScheduleDto | null>(null);
  readonly preview = output<void>();
  readonly openSchedule = output<void>();
  readonly viewLatest = output<void>();

  mode(): 'scheduled' | 'unscheduled' {
    return reportBannerMode(this.schedule());
  }
}
